
import { defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    setup() {
        const store = useStore();
        if (window.location.hash !== '#/login') {
            store.dispatch('getEnableSmartHomeOption');
        }
    }
});
